.common-header-container {
  display: flex;
  margin: 20px 0;

  .second-button {
    margin: 0 0 0 20px;
  }
}

.btn_common {
  min-width: 155px;
  background-color: var(--common-header-button-background);
  color: var(--common-header-button-text);
  border-color: var(--common-header-button-background);

  &:hover {
    background-color: var(--common-header-button-background);
    border-color: var(--common-header-button-background);
    color: var(--common-header-button-text);
  }
}

@media only screen and (max-width: 659px) {
  .common-header-container {
    flex-direction: column;
    margin: 10px 0;

    .second-button {
      margin: 10px 0 0;
    }
  }
}
